import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Modal from "../components/Modal";
import {
    getActionAuthentication,
    getConfig,
    setActionAuthentication,
} from "../reducers/configSlice";
import QRCode from "react-native-qrcode-svg";
import {StyleSheet, View} from "react-native";
import * as functions from "../services/helpers/dateTimeHelpers";


import {actuatedWithoutScale} from "../services/helpers/stylingHelpers";

const AuthenticationModal = () => {
    const dispatch = useDispatch()
    const authAction = useSelector(getActionAuthentication)
    const config = useSelector(getConfig)

    return (
        <Modal visible={authAction}
               onClose={() => {dispatch(setActionAuthentication(null))}}
               title={translate("Authentication required")}
               subtitle={translate("Please scan the QR code below with your phone")}
               disabled={false}
               buttonText={translate("Dismiss").toUpperCase()}
               onButtonPress={() => {dispatch(setActionAuthentication(null))}}
        >
            <View style={styles.qrWrapper}>
                {
                    authAction ?
                        <QRCode
                            value={authAction.link}
                            size={actuatedWithoutScale(250)}
                            quietZone={10}
                        /> : null
                }
            </View>
        </Modal>
    )
}

export default AuthenticationModal

const styles = StyleSheet.create({
    qrWrapper: {
        flex: 0.6,
        justifyContent: 'center',
        alignItems: 'center'
    },
});

